export const hasDST = () => {
    const januaryOffset = new Date(Date.UTC(new Date().getFullYear(), 0, 1)).getTimezoneOffset();
    const julyOffset = new Date(Date.UTC(new Date().getFullYear(), 6, 1)).getTimezoneOffset();
    return januaryOffset !== julyOffset;
}

export enum TimeRange {
  Custom = Infinity,
  OneWeek = 604800,
  OneDay = 86400,
  TwelveHours = 43200,
  SixHours = 21600,
  ThreeHours = 10800,
  OneHour = 3600,
  ThirtyMinutes = 1800,
  FifteenMinutes = 900,
  FiveMinutes = 300,
}

export const selectedDurationMap: { [key: string]: number } = {
    '1hour': TimeRange.OneHour,
    '3hour': TimeRange.ThreeHours,
    '6hour': TimeRange.SixHours,
    '12hour': TimeRange.TwelveHours,
    '1day': TimeRange.OneDay,
    'week': TimeRange.OneWeek,
    'custom': TimeRange.Custom,
};

export const allTimeLineChunks: { [label: string]: TimeRange } = {
    '1D': TimeRange.OneDay,
    '6H': TimeRange.SixHours,
    '3H': TimeRange.ThreeHours,
    '1H': TimeRange.OneHour,
    '30M': TimeRange.ThirtyMinutes,
    '15M': TimeRange.FifteenMinutes,
    '5M': TimeRange.FiveMinutes,
};
